<template>
  <div class="tw:flex tw:items-center tw:gap-1">
    <EdroneInput
      :placeholder="trans._menu.searchBar.placeholder"
      class="tw:max-w-[20rem]"
      unique-id="searchbar"
      @click="handleOpenSearchBar"
    >
      <template #icon>
        <i class="fa-light fa-search" />
      </template>
    </EdroneInput>
    <EdroneButtonIcon type="plain" @click="isAddClientModalOpen = true">
      <FontAwesomeIcon icon="fa-light fa-user-plus" />
    </EdroneButtonIcon>
  </div>

  <SearchBar
    :is-open="isOpenSearchBar"
    @close="handleCloseSearchBar"
    @preview-customer="customerPreview.send({ type: 'OPEN', customerId: $event })"
  />
  <AddClientModal :open="isAddClientModalOpen" @close="isAddClientModalOpen = false" @success="handleAddClient" />
  <CustomerPreview />
</template>

<script lang="ts" setup>
import EdroneInput from "edrone-components/EdroneInput.vue";
import { ref } from "vue";
import SearchBar from "../SearchBar/SearchBar.vue";
import CustomerPreview from "vue-app/components/Customer/CustomerPreview.vue";
import AddClientModal from "vue-app/components/common/AddClientModal.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { provideCustomerPreviewActor } from "vue-app/pages/machines/machineCustomerPreview.ts";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";

const isAddClientModalOpen = ref(false);

const customerPreview = provideCustomerPreviewActor();

const handleAddClient = (customerId: number) => {
  isAddClientModalOpen.value = false;
  customerPreview.send({ type: "OPEN", customerId: customerId });
};

const isOpenSearchBar = ref<boolean>(false);

const handleOpenSearchBar = () => {
  isOpenSearchBar.value = true;
};

const handleCloseSearchBar = () => {
  isOpenSearchBar.value = false;
};
</script>
